export const CompanyStatuses = {
  OPERATING: 'operating',
  COURT_PROCEDURE: 'court_procedure',
  SUSPENDED: 'suspended',
  UNKNOWN: 'unknown',
} as const;

export type CompanyStatus = (typeof CompanyStatuses)[keyof typeof CompanyStatuses];
